import React from 'react';

const Suitcase = ({ width = 24, height = 24, fill = '#666666', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 22V21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V8C5 7.45 5.19583 6.97917 5.5875 6.5875C5.97917 6.19583 6.45 6 7 6H9V3C9 2.71667 9.09583 2.47917 9.2875 2.2875C9.47917 2.09583 9.71667 2 10 2H14C14.2833 2 14.5208 2.09583 14.7125 2.2875C14.9042 2.47917 15 2.71667 15 3V6H17C17.55 6 18.0208 6.19583 18.4125 6.5875C18.8042 6.97917 19 7.45 19 8V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21V22H15V21H9V22H7ZM11 6H13V4H11V6ZM14.5875 11.6625C15.4292 11.4375 16.2333 11.1 17 10.65V8H7V10.65C7.76667 11.1 8.57083 11.4375 9.4125 11.6625C10.2542 11.8875 11.1167 12 12 12C12.8833 12 13.7458 11.8875 14.5875 11.6625ZM11 15V13.95C10.3 13.8667 9.61667 13.7417 8.95 13.575C8.28333 13.4083 7.63333 13.1833 7 12.9V19H17V12.9C16.3667 13.1833 15.7167 13.4083 15.05 13.575C14.3833 13.7417 13.7 13.8667 13 13.95V15H11Z" fill={fill}/>
  </svg>
);

export default Suitcase;
